import { Box, styled } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
const StyledBox = styled(Box)(({ ellipsis }) => ({
    ...(ellipsis && {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    }),
}));
export const H1 = (props) => {
    const { ellipsis, children, className, ...others } = props;
    return (
        <StyledBox
            fontSize={28}
            component="h1"
            fontWeight={600}
            ellipsis={ellipsis}
            className={clsx({
                [className || '']: true,
            })}
            {...others}
        >
            {children}
        </StyledBox>
    );
};

H1.propTypes = {
    ellipsis: PropTypes.any,
    children: PropTypes.any,
    className: PropTypes.any,
};

export const H2 = (props) => {
    const { ellipsis, children, className, ...others } = props;
    return (
        <StyledBox
            fontSize={24}
            component="h2"
            fontWeight={600}
            lineHeight={1}
            ellipsis={ellipsis}
            className={clsx({
                [className || '']: true,
            })}
            {...others}
        >
            {children}
        </StyledBox>
    );
};
H2.propTypes = {
    ellipsis: PropTypes.any,
    children: PropTypes.any,
    className: PropTypes.any,
};
export const H3 = (props) => {
    const { ellipsis, children, className, ...others } = props;
    return (
        <StyledBox
            fontSize={18}
            component="h3"
            fontWeight={600}
            ellipsis={ellipsis}
            className={clsx({
                [className || '']: true,
            })}
            {...others}
        >
            {children}
        </StyledBox>
    );
};
H3.propTypes = {
    ellipsis: PropTypes.any,
    children: PropTypes.any,
    className: PropTypes.any,
};
export const H4 = (props) => {
    const { ellipsis, children, className, ...others } = props;
    return (
        <StyledBox
            fontSize={16}
            component="h4"
            fontWeight={600}
            ellipsis={ellipsis}
            className={clsx({
                [className || '']: true,
            })}
            {...others}
        >
            {children}
        </StyledBox>
    );
};

H4.propTypes = {
    ellipsis: PropTypes.any,
    children: PropTypes.any,
    className: PropTypes.any,
};
export const H5 = (props) => {
    const { ellipsis, children, className, ...others } = props;
    return (
        <StyledBox
            fontSize={14}
            component="h5"
            lineHeight={1}
            fontWeight={600}
            ellipsis={ellipsis}
            className={clsx({
                [className || '']: true,
            })}
            {...others}
        >
            {children}
        </StyledBox>
    );
};
H5.propTypes = {
    ellipsis: PropTypes.any,
    children: PropTypes.any,
    className: PropTypes.any,
};
export const H6 = (props) => {
    const { ellipsis, children, className, ...others } = props;
    return (
        <StyledBox
            fontSize={13}
            component="h6"
            margin={0}
            fontWeight={600}
            ellipsis={ellipsis}
            className={clsx({
                [className || '']: true,
            })}
            {...others}
        >
            {children}
        </StyledBox>
    );
};
H6.propTypes = {
    ellipsis: PropTypes.any,
    children: PropTypes.any,
    className: PropTypes.any,
};
export const Paragraph = (props) => {
    const { ellipsis, children, className, ...others } = props;
    return (
        <StyledBox
            fontSize={14}
            component="p"
            fontWeight={500}
            ellipsis={ellipsis}
            className={clsx({
                [className || '']: true,
            })}
            {...others}
        >
            {children}
        </StyledBox>
    );
};
Paragraph.propTypes = {
    ellipsis: PropTypes.any,
    children: PropTypes.any,
    className: PropTypes.any,
};

export const Small = (props) => {
    const { ellipsis, children, className, ...others } = props;
    return (
        <StyledBox
            fontSize={13}
            component="small"
            fontWeight={500}
            lineHeight={1.6}
            ellipsis={ellipsis}
            className={clsx({
                [className || '']: true,
            })}
            {...others}
        >
            {children}
        </StyledBox>
    );
};
Small.propTypes = {
    ellipsis: PropTypes.any,
    children: PropTypes.any,
    className: PropTypes.any,
};
export const Span = (props) => {
    const { ellipsis, children, className, ...others } = props;
    return (
        <StyledBox
            fontSize={14}
            component="span"
            ellipsis={ellipsis}
            className={clsx({
                [className || '']: true,
            })}
            {...others}
        >
            {children}
        </StyledBox>
    );
};

Span.propTypes = {
    ellipsis: PropTypes.any,
    children: PropTypes.any,
    className: PropTypes.any,
};
export const Tiny = (props) => {
    const { ellipsis, children, className, ...others } = props;
    return (
        <StyledBox
            component="p"
            fontSize={13}
            fontWeight={500}
            lineHeight={1.65}
            ellipsis={ellipsis}
            color="text.secondary"
            className={clsx({
                [className || '']: true,
            })}
            {...others}
        >
            {children}
        </StyledBox>
    );
};
Tiny.propTypes = {
    ellipsis: PropTypes.any,
    children: PropTypes.any,
    className: PropTypes.any,
};
